export const TaskType =
{
    BySystem : 0,
    ByRandom : 1,
    ByCategory : 2
}